export const soumissionTranslations = {
  // Hero left
  breadcrumb_home: 'Accueil',
  breadcrumb_current: 'Soumission gratuite',
  hero_h1: "Votre soumission toiture à Lévis, livrée en 2h ouvrables",
  hero_subtitle: "Inspection gratuite, prix détaillé, garantie écrite 10 ans. Zéro engagement, zéro pression.",
  bullet_1: "Réponse en moins de 2h (jours ouvrables)",
  bullet_2: "Inspection sur place gratuite",
  bullet_3: "Soumission claire et détaillée par courriel",
  bullet_4: "Réseau de couvreurs RBQ certifiés",
  bullet_5: "Garantie écrite 10 ans",

  // Form
  form_title: "Demandez votre soumission en 60 secondes",
  form_step_1: "Étape 1 — Votre projet",
  form_step_2: "Étape 2 — Vos coordonnées",
  form_type_label: "Type de projet",
  form_type_refection: "Réfection complète",
  form_type_repair: "Réparation",
  form_type_inspection: "Inspection",
  form_type_flat: "Toit plat / Membrane",
  form_type_deneigement: "Déneigement",
  form_type_other: "Autre",
  form_material_label: "Type de toiture actuelle",
  form_material_bardeau: "Bardeau d'asphalte",
  form_material_tole: "Tôle / Métal",
  form_material_membrane: "Membrane élastomère",
  form_material_dontknow: "Je ne sais pas",
  form_delay_label: "Délai souhaité",
  form_delay_urgent: "Urgent",
  form_delay_short: "1-3 mois",
  form_delay_medium: "3-6 mois",
  form_delay_flexible: "Pas pressé",
  form_name_label: "Prénom et nom",
  form_name_placeholder: "Jean Tremblay",
  form_phone_label: "Numéro de téléphone",
  form_phone_placeholder: "418-476-9950",
  form_email_label: "Courriel",
  form_email_placeholder: "jean@email.com",
  form_address_label: "Adresse / secteur de Lévis",
  form_address_placeholder: "Votre adresse à Lévis (secteur)",
  form_message_label: "Message (optionnel)",
  form_message_placeholder: "Décrivez votre situation...",
  form_char_count: "/500",
  form_submit: "Envoyer ma demande →",
  form_reassurance: "Vos données restent confidentielles. On vous rappelle en 2h ouvrables.",
  form_back: "← Retour",
  form_next: "Continuer →",
  form_success: "Demande envoyée !",
  form_success_sub: "On vous rappelle dans moins de 2h ouvrables. Merci de nous faire confiance.",

  // Pourquoi nous
  why_h2: "Pourquoi 500+ propriétaires de Lévis utilisent notre plateforme",
  why_1_title: "Soumission claire en 2h chrono",
  why_1_desc: "Pas d'attente de 3 semaines. Vous recevez une soumission détaillée par courriel le jour même.",
  why_2_title: "Couvreurs partenaires vérifiés et assurés",
  why_2_desc: "Tous nos partenaires sont certifiés, couverts CNESST et assurance responsabilité civile 2M$.",
  why_3_title: "Garantie écrite 10 ans signée",
  why_3_desc: "Un contrat de garantie est remis avec chaque projet réalisé par nos partenaires. Pas de promesse orale, que du papier.",
  why_4_title: "Travail propre, nettoyage magnétique inclus",
  why_4_desc: "Aspirateur magnétique systématique après chaque chantier. Vos plantes, votre entrée, votre cour sont protégées.",

  // Process
  process_h2: "Ce qui se passe après votre demande",
  process_1_num: "01",
  process_1_title: "On vous rappelle en moins de 2h ouvrables",
  process_1_desc: "Un couvreur vérifie votre projet et vous pose les bonnes questions au téléphone.",
  process_2_num: "02",
  process_2_title: "On planifie une inspection gratuite (sous 48h)",
  process_2_desc: "On se rend sur place, on monte sur le toit, on prend des photos, on évalue l'état réel.",
  process_3_num: "03",
  process_3_title: "Vous recevez votre soumission détaillée par courriel",
  process_3_desc: "Prix par poste de travail, délais, matériaux recommandés, garanties. Rien n'est caché.",
  process_4_num: "04",
  process_4_title: "Vous décidez. Aucune pression, aucun engagement.",
  process_4_desc: "Comparez, réfléchissez, demandez des précisions. On est là quand vous êtes prêt.",

  // Témoignages
  reviews_h2: "Ce que nos clients de Lévis disent",
  review_1_text: "Soumission reçue en 1h30, claire, sans pression. Choix facile. L'équipe a fait le travail en 2 jours, nettoyage impeccable.",
  review_1_author: "Julie M.",
  review_1_detail: "Pintendre — Réfection toiture, août 2025",
  review_2_text: "L'équipe est arrivée à l'heure, a tout nettoyé, garantie remise signée. Pro du début à la fin. J'ai déjà recommandé à mon voisin.",
  review_2_author: "Marc T.",
  review_2_detail: "Saint-Romuald — Toit plat membrane, juin 2025",
  review_3_text: "Inspection honnête, ils m'ont dit qu'une réparation suffisait. Pas une réfection. Ils auraient pu me vendre une toiture neuve. Confiance acquise.",
  review_3_author: "Diane L.",
  review_3_detail: "Charny — Réparation bardeau, septembre 2025",

  // Garanties
  garanties_h2: "Vos garanties avec nos couvreurs partenaires",
  garantie_1: "Licence valide Régie du bâtiment du Québec",
  garantie_2: "Maître Couvreur certifié",
  garantie_3: "CCQ accréditation",
  garantie_4: "Garantie écrite 10 ans",
  garantie_5: "Assurance RC 2M$",

  // FAQ
  faq_h2: "Questions fréquentes",
  faq_q1: "La soumission est-elle vraiment gratuite ?",
  faq_a1: "Oui, à 100%. L'inspection sur place, la consultation et la soumission détaillée par courriel sont entièrement gratuits. Vous n'avez rien à payer tant que vous n'avez pas signé de contrat de travail. On n'impose aucun frais caché.",
  faq_q2: "Suis-je obligé d'accepter après inspection ?",
  faq_a2: "Non. Jamais. L'inspection et la soumission sont sans engagement. Vous recevez le document, vous prenez votre temps pour comparer, et vous décidez quand vous êtes prêt. Aucun représentant ne vous harcèlera au téléphone. C'est promis.",
  faq_q3: "Combien de temps est valide la soumission ?",
  faq_a3: "Nos soumissions sont valides pendant 90 jours. Cela vous donne le temps de comparer, de planifier votre budget ou d'attendre la bonne saison. Si les prix des matériaux changent significativement, on vous en avise et on ajuste ensemble.",
  faq_q4: "Travaillez-vous sur ma rue à Lévis ?",
  faq_a4: "On couvre tout Lévis et les secteurs avoisinants : Saint-Nicolas, Saint-Romuald, Charny, Pintendre, Desjardins. Si vous habitez dans la grande région de Lévis, on passe. Appelez-nous pour confirmer — on vous dira honnêtement si on peut se déplacer.",

  // CTA Final
  cta_h2: "Vous préférez parler directement à un couvreur ?",
  cta_subtitle: "Notre équipe répond 7 jours sur 7 pour vous mettre en relation avec un couvreur partenaire.",
  cta_phone: "418-476-9950",
  cta_hours: "Lun-Ven 7h-19h • Sam-Dim 9h-17h • Urgences 24h",

  // Shared
  phone_number: "418-476-9950",
};

export default soumissionTranslations;